module.exports = __webpack_public_path__ + "img/img90.c36139f6.svg";